import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Divider,
  MenuItem,
  useDisclosure,
} from '@chakra-ui/react';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SparkelIcon from './icon/SparkelIcon';

type DeleteMenuItemProps = {
  name: string;
  onDelete: () => Promise<void>;
  isDisabled?: boolean;
};

export const DeleteMenuItem: React.FC<DeleteMenuItemProps> = ({
  name,
  onDelete,
  isDisabled,
}) => {
  const {
    isOpen: isAlertOpen,
    onOpen: openAlert,
    onClose: closeAlert,
  } = useDisclosure();
  const [isDeleting, setIsDeleting] = useState(false);
  const cancelDeleteRef = useRef(null);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await onDelete();
      setIsDeleting(false);
      closeAlert();
    } catch (error) {
      console.error(error);
    }
    setIsDeleting(false);
  };

  const { t } = useTranslation();

  return (
    <>
      <MenuItem
        aria-label="Delete"
        icon={<SparkelIcon icon={faTrash} color="red.400" fixedWidth />}
        onClick={openAlert}
        textColor="red.400"
        isDisabled={isDisabled}
      >
        {t('delete')}
      </MenuItem>

      <AlertDialog
        isOpen={isAlertOpen}
        onClose={closeAlert}
        leastDestructiveRef={cancelDeleteRef}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader>
              {t('delete')} {name}?
            </AlertDialogHeader>
            <Divider mb={2} orientation="horizontal" />
            <AlertDialogBody>{t('delete.warning')}</AlertDialogBody>
            <Divider mt={2} orientation="horizontal" />
            <AlertDialogFooter columnGap={2}>
              <Button
                ref={cancelDeleteRef}
                colorScheme="gray"
                onClick={closeAlert}
              >
                {t('cancel')}
              </Button>
              <Button
                colorScheme="red"
                onClick={handleDelete}
                isLoading={isDeleting}
                loadingText="Deleting"
              >
                {t('delete')}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default DeleteMenuItem;
